import React, { useRef, useEffect } from 'react';
import QRCode from 'qrcode';

export function generateQrHash() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export function RealQRCode({ value, size = 128, darkColor = '#000000', lightColor = '#ffffff' }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    if (!canvasRef.current || !value) return;
    QRCode.toCanvas(canvasRef.current, value, {
      width: size,
      margin: 1,
      color: { dark: darkColor, light: lightColor },
      errorCorrectionLevel: 'M',
    });
  }, [value, size, darkColor, lightColor]);
  return <canvas ref={canvasRef} style={{ display: 'block', imageRendering: 'pixelated' }} />;
}

// qrEncode kept for the print function in ZoneView — now uses the real library
export async function qrEncodeToCanvas(value, canvas, size = 200) {
  await QRCode.toCanvas(canvas, value, {
    width: size,
    margin: 2,
    color: { dark: '#000000', light: '#ffffff' },
    errorCorrectionLevel: 'M',
  });
}
